import { createLineItemValidatonAtoms } from '../../common/validation'
import { formStateAtom } from './state.atoms'

const { validationResultsAtom, validateFormAtom } =
  createLineItemValidatonAtoms(formStateAtom)

export { validationResultsAtom, validateFormAtom }
